import React from 'react'
import Highcharts from 'highcharts'
import HighchartsWrapper from './HighChartsWrapper'
import { BarChartCardProps } from '../../utils'

const BarChartCard: React.FC<BarChartCardProps> = ({
  categories,
  series,
  xAxisTitle = '',
  yAxisTitle = '',
  showLegend = true,
}) => {
  const chartOptions: Highcharts.Options = {
    chart: {
      type: 'bar',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories,
      title: {
        text: xAxisTitle,
        style: {
          fontWeight: '500',
          color: 'var(--accent-900)',
          fontSize: '18px',
        },
        margin: 30,
      },
      labels: {
        style: {
          color: 'var(--accent-900)',
          fontSize: '14px',
          fontWeight: '300',
        },
      },
    },
    yAxis: {
      title: {
        text: yAxisTitle,
        style: {
          fontWeight: '500',
          color: 'var(--accent-900)',
          fontSize: '18px',
        },
        margin: 20,
      },
      gridLineColor: 'var(--accent-100)',
      labels: {
        style: {
          color: 'var(--accent-900)',
          fontSize: '14px',
          fontWeight: '300',
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      backgroundColor: 'rgba(255,255,255,0.95)',
      borderColor: '#ccc',
      style: {
        color: '#000',
        fontSize: '13px',
      },
    },
    plotOptions: {
      bar: {
        pointPadding: 0.2,
        groupPadding: 0.1,
        states: {
          hover: {
            enabled: true,
            brightness: 0.1,
          },
        },
      },
    },
    legend: showLegend
      ? {
          align: 'right',
          verticalAlign: 'middle',
          layout: 'vertical',
          itemStyle: { color: 'var(--accent-900)', fontWeight: '500' },
        }
      : {
          enabled: false,
        },
    series: series.map((s) => ({
      ...s,
      type: 'bar',
    })),
    credits: {
      enabled: false,
    },
  }

  return (
    <HighchartsWrapper
      options={chartOptions}
      containerProps={{ className: 'h-fit w-full' }}
    />
  )
}

export default BarChartCard
